import { render, staticRenderFns } from "./NewTransmitterEvent.vue?vue&type=template&id=79b47440&scoped=true&"
import script from "./NewTransmitterEvent.vue?vue&type=script&lang=js&"
export * from "./NewTransmitterEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b47440",
  null
  
)

export default component.exports